import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { SlSelect } from '@shoelace-style/shoelace';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  }
})
export class MultiSelectComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {

  @ViewChild("multiSelect") multiSelect!: ElementRef<SlSelect>;

  ngAfterViewInit(): void {
    // This is a workaround for setting the default selected values since Shoelace has a bug reported
    // on the default values not being set. We will keep an eye out for a fix for this.
    if (this.multiSelect.nativeElement) {
      this.multiSelect.nativeElement.setAttribute("value", this.field.defaultValue?.join(" "));
    }
  }

  getOptions(): any[] {
    // It's safe to assume `prop.options` is type `any[]` since we pass in the values via API to the prop options
    return this.props.options as any[];
  }

  onSelectionChange(event: CustomEvent) {
    const value: string = (event.target as SlSelect).value as string;
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();
  }
}